import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  changeFile(event){
    document.getElementById(event.params.containerId).classList.toggle("hidden")
  }
}